import { c as _c } from "react/compiler-runtime";
import { Tabs } from '@chakra-ui/react';
import { AdvisorMiniProfile } from '@src/components/sco/Advisors/layout/AdvisorMiniProfile';
import { FounderMiniProfile } from '@src/components/sco/Advisors/layout/FounderMiniProfile';
import { ManageEngagementPanel } from '@src/components/sco/Advisors/layout/ManageEngagementPanel';
import { ScoAdvisorEngagement } from '@src/graphql-types';
import { useState } from 'react';
import { LuSettings2, LuUser } from 'react-icons/lu';
type EngagementAsidePanelProps = {
  engagement: ScoAdvisorEngagement;
  /**
   * Profile tab content:
   * - `advisor` — founder viewing an advisor (or Wil)
   * - `founder` — advisor viewing a founder
   */
  profilePerspective: 'advisor' | 'founder';
};

/**
 * Right-rail panel for an engagement: person profile + manage lifecycle/chat.
 * Used on ask / ask-advisors / my-founders surfaces.
 */
export const EngagementAsidePanel = t0 => {
  const $ = _c(21);
  const {
    engagement,
    profilePerspective
  } = t0;
  const [tab, setTab] = useState("profile");
  const profileLabel = profilePerspective === "founder" ? "Founder" : "Advisor";
  const engagementKey = engagement.advisorEngagementId || engagement.id || engagement.advisorUserId || engagement.founderUserId || "engagement";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = details => setTab(details.value);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LuUser />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== profileLabel) {
    t3 = <Tabs.Trigger flex={1} gap={1.5} justifyContent="center" value="profile">{t2}{profileLabel}</Tabs.Trigger>;
    $[2] = profileLabel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Tabs.Trigger flex={1} gap={1.5} justifyContent="center" value="manage"><LuSettings2 />Manage</Tabs.Trigger>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Tabs.List flexShrink={0} width="full">{t3}{t4}</Tabs.List>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      animation: "none"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== engagement || $[9] !== profilePerspective) {
    t7 = <Tabs.Content _open={t6} flex={1} minHeight={0} overflowY="auto" paddingTop={4} value="profile">{profilePerspective === "founder" ? <FounderMiniProfile engagement={engagement} /> : <AdvisorMiniProfile engagement={engagement} />}</Tabs.Content>;
    $[8] = engagement;
    $[9] = profilePerspective;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      animation: "none"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== engagement || $[13] !== profilePerspective) {
    t9 = <Tabs.Content _open={t8} flex={1} minHeight={0} overflowY="auto" paddingTop={4} value="manage"><ManageEngagementPanel engagement={engagement} profilePerspective={profilePerspective} /></Tabs.Content>;
    $[12] = engagement;
    $[13] = profilePerspective;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== engagementKey || $[16] !== t5 || $[17] !== t7 || $[18] !== t9 || $[19] !== tab) {
    t10 = <Tabs.Root key={engagementKey} display="flex" flexDirection="column" height="full" minHeight={0} size="sm" value={tab} variant="enclosed" width="full" onValueChange={t1}>{t5}{t7}{t9}</Tabs.Root>;
    $[15] = engagementKey;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = tab;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};